import Icons from '../icons';
import React from 'react';
import { Container, Header, Item, Tag } from './style';
import { PlaceholderType } from 'shared/types';

type PlaceholderMenuProps = {
  onClose: any;
  initialExpand: boolean;
  placeholders: PlaceholderType[];
  onSelect: any;
};

const PlaceholderMenu = ({
  onClose = () => undefined,
  initialExpand = false,
  placeholders = [],
  onSelect = () => undefined,
}: PlaceholderMenuProps) => {
  const [maximized, setMaximized] = React.useState<any>({});

  React.useEffect(() => {
    if (initialExpand && placeholders && placeholders.length > 0) {
      const max: any = {};
      placeholders.forEach((placeholder: any) => {
        max[placeholder.id] = true;
      });
      setMaximized(max);
    }
  }, []);

  return (
    <Container onClick={(e) => e.stopPropagation()}>
      <Header>
        <div className="heading">Placeholder</div>
        <div className="close" role="none" onClick={onClose}>
          <Icons glyph="close-mini" size={20} viewBox="0 0 20 20" />
        </div>
      </Header>
      <div className="pl-menu-items">
        {placeholders.map(
          (item) =>
            item.options && (
              <Item key={item.id}>
                <div
                  className="icon"
                  role="none"
                  onClick={() =>
                    setMaximized({
                      ...maximized,
                      [item.id]: !maximized[item.id],
                    })
                  }
                >
                  <Icons
                    glyph="arrowdown"
                    size={14}
                    viewBox="0 0 32 32"
                    style={{
                      transition: 'transform 0.2s ease-in',
                      transform: maximized[item.id]
                        ? 'rotate(0deg)'
                        : 'rotate(-90deg)',
                    }}
                  />
                </div>
                <div className="data">
                  {item.name && (
                    <div
                      className="group-name"
                      role="none"
                      onClick={() =>
                        setMaximized({
                          ...maximized,
                          [item.id]: !maximized[item.id],
                        })
                      }
                    >
                      {item.name}
                    </div>
                  )}
                  {maximized[item.id] && (
                    <div className="group-options">
                      {item.options &&
                        item.options.map((option: any) => (
                          <Tag
                            key={option.id}
                            onClick={() => onSelect(option.placeholder)}
                          >
                            {option.name}
                          </Tag>
                        ))}
                    </div>
                  )}
                </div>
              </Item>
            ),
        )}
      </div>
    </Container>
  );
};

export default PlaceholderMenu;
